import { ResourceStatus, ResourceStatusLabels } from '@navio/nsdk';
import { NoddiBadge, type BadgeVariant } from 'noddi-ui-web';

const VARIANT_BY_STATUS: Record<ResourceStatus, BadgeVariant> = {
  [ResourceStatus.ACTIVE]: 'success',
  [ResourceStatus.OUT_OF_ORDER]: 'destructive',
  [ResourceStatus.DISABLED_HIDE]: 'outline',
  [ResourceStatus.DISABLED_SHOW]: 'outline'
};

type Props = {
  status: ResourceStatus;
  className?: string;
};

export const ResourceStatusBadge = ({ status, className }: Props) => (
  <NoddiBadge variant={VARIANT_BY_STATUS[status]} withCircle className={className}>
    {ResourceStatusLabels[status]}
  </NoddiBadge>
);
